"use strict";
/*
 * Created on 29.01.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ReplePromoManagementDetailFilter_1 = require("../filters/ReplePromoManagementDetailFilter");

var ReplePromoManagementDetailFilterConverter_1 = require("./ReplePromoManagementDetailFilterConverter");
/**
 * @author Tomáš Leity
 */


var ReplePromoManagementDetailFilterConverterImpl =
/*#__PURE__*/
function (_ReplePromoManagement) {
  _inherits(ReplePromoManagementDetailFilterConverterImpl, _ReplePromoManagement);

  function ReplePromoManagementDetailFilterConverterImpl() {
    _classCallCheck(this, ReplePromoManagementDetailFilterConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ReplePromoManagementDetailFilterConverterImpl).apply(this, arguments));
  }

  _createClass(ReplePromoManagementDetailFilterConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new ReplePromoManagementDetailFilter_1.ReplePromoManagementDetailFilter(ReplePromoManagementDetailFilter_1.ReplePromoManagementDetailFilter.schema.windowItemIds.valueOf(conversions.asClassReferenceIdsList(source, 'windowItemIds')), ReplePromoManagementDetailFilter_1.ReplePromoManagementDetailFilter.schema.categoryIds.valueOf(conversions.asClassReferenceIdsList(source, 'categoryIds')), ReplePromoManagementDetailFilter_1.ReplePromoManagementDetailFilter.schema.supplierIds.valueOf(conversions.asClassReferenceIdsList(source, 'supplierIds')), ReplePromoManagementDetailFilter_1.ReplePromoManagementDetailFilter.schema.productIds.valueOf(conversions.asClassReferenceIdsList(source, 'productIds')));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        windowItemIds: source.windowItemIds ? conversions.asObjectArray(source, 'windowItemIds', function (id) {
          return conversions.toDocumentReferenceId(id);
        }) : null,
        categoryIds: source.categoryIds ? conversions.asObjectArray(source, 'categoryIds', function (id) {
          return conversions.toDocumentReferenceId(id);
        }) : null,
        supplierIds: source.supplierIds ? conversions.asObjectArray(source, 'supplierIds', function (id) {
          return conversions.toDocumentReferenceId(id);
        }) : null,
        productIds: source.productIds ? conversions.asObjectArray(source, 'productIds', function (id) {
          return conversions.toDocumentReferenceId(id);
        }) : null
      });
      return result;
    }
  }]);

  return ReplePromoManagementDetailFilterConverterImpl;
}(ReplePromoManagementDetailFilterConverter_1.ReplePromoManagementDetailFilterConverter);

exports.ReplePromoManagementDetailFilterConverterImpl = ReplePromoManagementDetailFilterConverterImpl;